import { makeStyles } from '@mui/styles'

const fallbackLoaderStyles = makeStyles(theme => ({
  fallBackLoaderWrapper: {
    height: '100vh',
  },
}))
export default fallbackLoaderStyles
